"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const get_1 = __importDefault(require("lodash/get"));
const mobx_1 = require("mobx");
const makeExtensionPayment_1 = __importDefault(require("../../clients/applepay/makeExtensionPayment"));
const makePayment_1 = __importDefault(require("../../clients/applepay/makePayment"));
const makeQuickPayPayment_1 = __importDefault(require("../../clients/applepay/makeQuickPayPayment"));
const validateSession_1 = __importDefault(require("../../clients/applepay/validateSession"));
const constants_1 = require("../../constants");
const getApplePayCustomError_1 = __importDefault(require("../../utils/error/getApplePayCustomError"));
const setPaymentCookie_1 = __importDefault(require("../../utils/payment/setPaymentCookie"));
const mapInitialStateToStoreState_1 = __importDefault(require("../../utils/store/mapInitialStateToStoreState"));
/**
 * Apple Pay Domain Store
 */
class ApplePayStore {
    constructor(initialState, $env) {
        /**
         * Initializes Apple Pay
         * Creates Apple Session object
         * @param {RequestObjectType} requestObj
         * @param {string} rtoken Google recaptcha token
         * @param {string} quoteId
         * @param {object} extraParams
         * @param {boolean} isQuickPay
         * @param {boolean} isExtensionPay
         * @returns {void}
         */
        this.initializeApplePay = (requestObj, quoteId, successHandler, errorHandler, extraParams, isQuickPay, isExtensionPay = false) => {
            /**
             * Creating a new Apple Pay session
             * https://developer.apple.com/documentation/apple_pay_on_the_web/apple_pay_js_api/creating_an_apple_pay_session
             */
            const session = new global.ApplePaySession(6, requestObj);
            session.begin();
            /**
             * This is the first event that Apple triggers.
             * An event handler the system calls when it displays the payment sheet.
             * Here you need to validate the Apple pay session from your backend
             * This gives a Apple pay session object (5 mins validity)
             * @param {*} event
             * https://developer.apple.com/documentation/apple_pay_on_the_web/applepaysession/1778021-onvalidatemerchant
             */
            session.onvalidatemerchant = (event) => __awaiter(this, void 0, void 0, function* () {
                try {
                    const validationUrl = event.validationURL;
                    console.log('** Validation Url: ', validationUrl);
                    // make call
                    const response = yield (0, validateSession_1.default)(validationUrl);
                    console.log('** Validation response: ', response);
                    // 200 http codes
                    session.completeMerchantValidation(response);
                }
                catch (err) {
                    // all other http codes
                    console.log('** Error while validating session: ', err);
                    session.abort(); // Aborts the current Apple Pay session.
                    this.onError(err, errorHandler);
                }
            });
            /**
             * This triggers after the user has confirmed the transaction
             * with Touch ID or Face ID
             * This will give the payment token
             * https://developer.apple.com/documentation/apple_pay_on_the_web/applepaysession/1778020-onpaymentauthorized
             * https://developer.apple.com/documentation/apple_pay_on_the_web/applepaysession/1778012-completepayment
             */
            session.onpaymentauthorized = (event) => __awaiter(this, void 0, void 0, function* () {
                // get payment token from apple
                const applePaymentToken = event.payment.token;
                console.log('** Apple pay token: ', applePaymentToken);
                try {
                    const reqParam = Object.assign({ paymentType: constants_1.PAYMENT_TYPE.CHECKOUT, paidThrough: constants_1.PAYMENT_TYPE.APPLE_PAY, tokenData: {
                            applePay: (0, get_1.default)(applePaymentToken, 'paymentData', {}),
                        } }, extraParams);
                    console.log('** Apple pay reqParam: ', reqParam);
                    let response;
                    // make call
                    if (isExtensionPay) {
                        response = yield (0, makeExtensionPayment_1.default)(reqParam, quoteId);
                    }
                    else if (isQuickPay) {
                        response = yield (0, makeQuickPayPayment_1.default)(reqParam, quoteId);
                    }
                    else {
                        response = yield (0, makePayment_1.default)(reqParam, quoteId);
                    }
                    console.log('** Apple pay response: ', response);
                    // 200 http codes
                    const paymentStatus = (0, get_1.default)(response, 'paymentStatus', constants_1.PAYMENT_STATUS.FAILED);
                    if (paymentStatus === constants_1.PAYMENT_STATUS.SUCCESS) {
                        // payment success
                        // inform apple about successfully payment
                        session.completePayment(global.ApplePaySession.STATUS_SUCCESS);
                        // invoke success handler
                        this.onSuccess(response, successHandler);
                    }
                    else {
                        // payment failed
                        // inform apple about failed payment
                        session.completePayment(global.ApplePaySession.STATUS_FAILURE);
                        // throw custom error
                        const errObj = (0, getApplePayCustomError_1.default)();
                        this.onError(errObj, errorHandler);
                    }
                }
                catch (err) {
                    // payment failed
                    console.log('** Apple pay failed: ', err);
                    // all other http codes
                    // inform apple about failed payment
                    session.completePayment(global.ApplePaySession.STATUS_FAILURE);
                    this.onError(err, errorHandler);
                }
            });
            session.oncancel = () => {
                console.log('** apple pay cancelled');
            };
        };
        /**
         * on success callback
         * @param data
         */
        this.onSuccess = (data, successHandler) => {
            // add token to cookie if present
            // see CardCheckoutStore for documentation
            const ptoken = (0, get_1.default)(data, 'token', '');
            ptoken && (0, setPaymentCookie_1.default)(ptoken);
            if (successHandler) {
                successHandler(data); // passes the response object back
            }
            console.log('onSuccess end');
        };
        /**
         * on error callback
         * @param err
         * @param errorHandler
         */
        this.onError = (err, errorHandler) => {
            // when a request is cancelled, Axios promise is rejected
            if (err.response) {
                const errResponse = err.response;
                if (errorHandler) {
                    errorHandler(errResponse); // {data: , status: }
                }
            }
        };
        /**
         * Map initial state to store state
         * @param initialState
         */
        this.updateInitialState = (initialState) => {
            (0, mapInitialStateToStoreState_1.default)(this, initialState);
        };
        this.$env = $env;
        this.updateInitialState(initialState);
    }
}
__decorate([
    mobx_1.action.bound
], ApplePayStore.prototype, "onSuccess", void 0);
__decorate([
    mobx_1.action.bound
], ApplePayStore.prototype, "onError", void 0);
__decorate([
    mobx_1.action.bound
], ApplePayStore.prototype, "updateInitialState", void 0);
exports.default = ApplePayStore;
